import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    background: {
      default: '#edf0f6',
    },
    primary: {
      main: '#003476',
      fontSize: 13
    },
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
    
  },
});

export default theme;
